<template>
    <CContainer class="d-flex content-center min-vh-100">
        <b-row class="justify-content-center" no-gutters>
            <b-col>
                <b-card-group>
                    <b-card no-body class="p-4">
                        <b-card-body >
                            <b-form v-if="$route.query.action == 'change'" validated
                                @submit.prevent="changePassword()">
                                <h1>
                                    <i class="fa fa-key pr-2 mb-4"></i>New Password
                                </h1>
                                <p>You must now change your password to Sign In</p>
                                <b-input-group class="mb-3">
                                    <b-input-group-prepend>
                                        <b-input-group-text>
                                            <i class="fa fa-user"></i>
                                        </b-input-group-text>
                                    </b-input-group-prepend>
                                    <b-form-input type="email" id="normalEmail" required v-model="email"
                                        :disabled="true" placeholder="Enter Email" autocomplete="new-password" />
                                    <b-form-invalid-feedback id="usernameFeedback">Email is
                                        required</b-form-invalid-feedback>
                                </b-input-group>
                                <small id="passwordHelpBlockMD" class="form-text text-muted mb-3">{{ password_policy
                                }}</small>
                                <b-input-group class="mb-2">
                                    <b-input-group-prepend>
                                        <b-input-group-text>
                                            <i class="fa fa-key"></i>
                                        </b-input-group-text>
                                    </b-input-group-prepend>
                                    <b-form-input type="password" id="password1" required v-model="password1"
                                        :disabled="busy" :state="password1Valid" @keyup.native="checkpassword1()"
                                        placeholder="<type new passsword>" autocomplete="new-password" />

                                    <b-form-invalid-feedback id="passwordFeedback">{{ password1_feedback
                                    }}</b-form-invalid-feedback>
                                </b-input-group>
                                <b-input-group class="mb-4">
                                    <b-input-group-prepend>
                                        <b-input-group-text>
                                            <i class="fa fa-key"></i>
                                        </b-input-group-text>
                                    </b-input-group-prepend>
                                    <b-form-input type="password" id="password2" required v-model="password2"
                                        :disabled="busy" :state="password2Valid" @keyup.native="checkpassword2()"
                                        placeholder="<type new passsword>" autocomplete="new-password" />
                                    <b-form-invalid-feedback id="passwordFeedback">{{ password2_feedback
                                    }}</b-form-invalid-feedback>

                                </b-input-group>
                                <b-alert :show="reset">Thank-you, your password has now been changed, a confirmation email
                                    has been sent.</b-alert>
                                <b-alert :show="message?true:false" variant="danger" >{{ message }}</b-alert>
                                <b-row class="text-left">
                                    <b-col cols="6">
                                        <b-button type="submit" variant="primary" class="px-4"
                                            :disabled="!(password1Valid && password2Valid && !reset)">Save Password</b-button>&nbsp;
                                        <img v-show="busy"
                                            src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                                    </b-col>
                                </b-row>
                                <div class="mt-4">
                                    <span class="text-muted">Return to</span>
                                    <router-link class="pl-2" to="/signin">Sign in</router-link>
                                </div>
                            </b-form>

                            <b-form v-if="$route.query.action == 'forgot'" validated
                                @submit.prevent="handleResetUser()">
                                <h1>
                                    <i class="fa fa-key pr-2 mb-4"></i>Forgot Password
                                </h1>
                                <p>Tell us your email address!</p>
                                <b-input-group class="mb-3">
                                    <b-input-group-prepend>
                                        <b-input-group-text>
                                            <i class="fa fa-user"></i>
                                        </b-input-group-text>
                                    </b-input-group-prepend>
                                    <b-form-input type="email" id="normalEmail" required v-model="email"
                                        :disabled="busy" placeholder="Enter Email" autocomplete="new-email" />
                                    <b-form-invalid-feedback id="usernameFeedback">Email is
                                        required</b-form-invalid-feedback>
                                </b-input-group>

                                <b-alert :show="reset">Thank-you, if your email address is known to us you will receive
                                    a password reset email
                                    shortly.</b-alert>
                                    {{ message }}
                                <!-- <b-alert :show="message?true:false">{{ message }}</b-alert> -->

                                <b-row class="text-left">
                                    <b-col cols="6">
                                        <b-button type="submit" variant="primary" class="px-4"
                                            :disabled="reset">Password Reset</b-button>&nbsp;
                                        <img v-show="busy"
                                            src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                                    </b-col>
                                </b-row>

                                <div class="mt-4">
                                    <span class="text-muted">Return to</span>
                                    <router-link class="pl-2" to="/signin">Sign in</router-link>
                                </div>
                            </b-form>

                        </b-card-body>
                    </b-card>
                </b-card-group>
            </b-col>
        </b-row>
    </CContainer>
</template>

<script>
import gql from "graphql-tag";

function parseJwt(token) {
    let jsonPayload = "{\"iat\":0,\"exp\":0}"
    if (token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        jsonPayload = decodeURIComponent(Buffer.from(base64, "base64").toString("ascii").split("").map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));
    }
    return JSON.parse(jsonPayload);
};


export default {
    name: "Reset",
    data() {
        return {
            ipinfo: "",
            busy: false,
            reset: false,
            email: null,
            token: null,
            message: null,
            password1: null,
            password1Valid: false,
            password2: null,
            password2Valid: false,
            password1_feedback: "Password is required",
            password2_feedback: "Password is required",
            password_policy: "",
            password_expression: "",
        };
    },
    async mounted() {
        await this.loaddata();
    },
    methods: {
        async loaddata() {
            this.ipservice_url = await this.getsystemsetting("ipservice_url");
            if (this.$route.query.token) {
                this.token = parseJwt(this.$route.query.token)
            }
            if (this.$route.query.email) {
                this.email = this.$route.query.email
            }
            if (this.$route.query.action == 'change') {
                this.password_policy = await this.getsystemsetting("password_policy");
                this.password_expression = await this.getsystemsetting("password_expression");
            }
        },
        async getsystemsetting(name) {
            const response = await this.$apollo.query({
                query: gql`
            query setup_systemsettings($name: String) {
              setup_systemsettings(name: $name) {
                data
              }
            }
          `,
                variables: { name }
            });
            let result = response.data.setup_systemsettings[0].data;
            return result;
        },
        async get_ipaddress() {
            let result = "";
            // if (this.ipservice_url) {
            //   let ipinfo = await axios.get(this.ipservice_url);
            //   result = ipinfo.data.ip;
            // } else {
            result = "127.0.0.1";
            // }
            return result;
        },
        checkpassword1() {
            // CHECK POLICY
            let complexity = new RegExp(this.password_expression);
            if (complexity.test(this.password1)) {
                this.password1_feedback = "Password is OK";
                this.password1Valid = true;
                return true;
            } else {
                this.password1_feedback =
                    "Password does not meet the complexity requirements";
                this.password1Valid = false;
                return false;
            }
        },
        checkpassword2() {
            // CHECK POLICY
            let complexity = new RegExp(this.password_expression);
            if (complexity.test(this.password2)) {
                this.password2_feedback = "Password is OK";
            } else {
                this.password2_feedback =
                    "Password does not meet the complexity requirements";
                this.password2Valid = false;
                return false;
            }
            if (this.password1 == this.password2) {
                this.password2Valid = true;
                return true;
            } else {
                this.password2_feedback = "Password must match";
                this.password2Valid = false;
                return false;
            }
        },
        forgotPassword() {
            let variables = {
                rows: [{ email: this.email.toLowerCase() }],
                action: "forgot"

            }
            this.busy = true
            this.$apollo
                .query({
                    query: gql`
                        query setup_users_email($rows: [setup_users_input], $action: String) {
                            setup_users_email(rows: $rows, action: $action) {
                                id
                            }
                        }
                        `,
                    variables
                })
                .then(({ data }) => {
                    if (data.setup_users_email.length > 0) {
                        this.reset = true
                    }
                })
                .catch(err => {
                    console.error(err);
                });

            this.busy = false
        },
        changePassword() {

            let variables = {
                rows: [{ id: this.token.id, password: this.password1 }],
                token: this.$route.query.token
            }

            this.busy = true
            this.$apollo
                .mutate({
                    mutation: gql`
                        mutation setup_users_save($rows: [setup_users_input], $token: String) {
                            setup_users_save(rows: $rows, token: $token) {
                                id
                            }
                        }
                    `,
                    variables
                })
                .then(({ data }) => {
                    if (data.setup_users_save.length > 0) {
                        this.reset = true
                    }
                })
                .catch(err => {
                    this.message = err.message
                });

            this.busy = false
        },
        handleResetPassword() {
            this.changePassword();
        },
        handleResetUser() {
            this.forgotPassword();
        }
    }
};
</script>